import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LegalComponent } from '@app/_v2/legal/legal.component';
import { PrivacyPolicyComponent } from '@app/_v2/legal/legals/privacy-policy.component';
import { BonusTermsComponent } from '@app/_v2/legal/legals/bonus-terms.component';
import { TermsAndConditionsComponent } from '@app/_v2/legal/legals/terms-and-conditions.component';

const routes: Routes = [
  {
    path: '',
    component: LegalComponent,
    data: { allowChat: false },
    children: [
      {
        path: '',
        component: TermsAndConditionsComponent,
        data: { title: 'Edgeless - Terms & Conditions' },
      },
      {
        path: 'terms-and-conditions',
        component: TermsAndConditionsComponent,
        data: { title: 'Edgeless - Terms & Conditions' },
      },
      {
        path: 'privacy-policy',
        component: PrivacyPolicyComponent,
        data: { title: 'Edgeless - Privacy Policy' },
      },
      {
        path: 'bonus-terms',
        component: BonusTermsComponent,
        data: { title: 'Edgeless - Bonus terms' },
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [],
})
export class LegalRoutingModule {}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/_v2/legal/legal-routing.module.ts